import { createContext } from 'react';

export const ErrorDialogContext = createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setOpenErrorDialog: (value: boolean) => { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setErrorMessage: (value: string) => { }
});
